/* eslint-disable */
import React from "react";

/* ─────────────────────────────────────────────
   INLINE CSS — all classes prefixed with .stw-
───────────────────────────────────────────── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
.stw-wrap { font-family: 'Inter','Outfit',sans-serif; }

/* NAV */
.stw-nav { display:flex;gap:0;margin-bottom:32px;background:#f1f5f9;border-radius:14px;padding:4px;overflow-x:auto; }
.stw-nav-item { flex:1;min-width:108px;padding:10px 6px;text-align:center;font-size:11px;font-weight:600;color:#94a3b8;border-radius:10px;cursor:pointer;transition:all .25s;white-space:nowrap; }
.stw-nav-item.active { background:#FD6101;color:#fff;box-shadow:0 4px 14px rgba(124,58,237,.35); }
.stw-nav-item.done { color:#FD6101; }

/* CARD */
.stw-card { background:#fff;border:1px solid #e2e8f0;border-radius:18px;padding:32px;box-shadow:0 4px 24px rgba(0,0,0,.04); }
.stw-card-sm { max-width:680px;margin:0 auto; }
.stw-card-md { max-width:840px;margin:0 auto; }

/* HEADINGS */
.stw-title { font-size:22px;font-weight:800;color:#0f172a;margin:0 0 4px;text-align:center; }
.stw-sub   { font-size:13px;color:#64748b;margin:0 0 28px;text-align:center; }

/* FORM */
.stw-label { font-size:11.5px;font-weight:700;color:#475569;letter-spacing:.04em;text-transform:uppercase;margin-bottom:6px;display:flex;align-items:center;gap:5px; }
.stw-input { width:100%;background:#f8fafc;border:1.5px solid #e2e8f0;border-radius:10px;padding:11px 14px;font-size:14px;color:#0f172a;outline:none;transition:all .2s;box-sizing:border-box; }
.stw-input:focus { border-color:#FD6101;background:#fff;box-shadow:0 0 0 3px rgba(124,58,237,.1); }
.stw-select { appearance:none;cursor:pointer; }

/* CHOICE CARDS */
.stw-cgrid-2 { display:grid;grid-template-columns:1fr 1fr;gap:12px; }
.stw-cgrid-4 { display:grid;grid-template-columns:repeat(4,1fr);gap:12px; }
.stw-cgrid-5 { display:grid;grid-template-columns:repeat(5,1fr);gap:10px; }
@media(max-width:640px){.stw-cgrid-4,.stw-cgrid-5{grid-template-columns:1fr 1fr;}}
.stw-choice { border:2px solid #e2e8f0;border-radius:14px;padding:16px 14px;cursor:pointer;transition:all .2s;background:#fff;text-align:center; }
.stw-choice:hover { border-color:#c4b5fd;background:#faf5ff;transform:translateY(-1px); }
.stw-choice.sel { border-color:#FD6101;background:#fff7ed;box-shadow:0 4px 14px rgba(253,97,1,.18); }
.stw-choice-icon  { font-size:22px;margin-bottom:6px; }
.stw-choice-title { font-size:13px;font-weight:700;color:#1e293b; }
.stw-choice-desc  { font-size:11px;color:#64748b;margin-top:3px;line-height:1.4; }
.stw-choice.sel .stw-choice-title { color:#FD6101; }

/* JOURNEY */
.stw-journey { display:flex;align-items:center;gap:8px;flex-wrap:wrap;background:#fff7ed;border:1.5px solid #fed7aa;border-radius:12px;padding:16px 20px;margin-bottom:20px; }
.stw-journey-step { background:#FD6101;color:#fff;padding:6px 14px;border-radius:20px;font-size:12px;font-weight:700; }
.stw-journey-arrow { color:#FD6101;font-size:16px;font-weight:bold; }

/* AI CARD */
.stw-ai-card { background:#002247;border:1.5px solid #FD6101;border-radius:18px;padding:24px;color:#fff;margin-bottom:24px;position:relative;overflow:hidden; }
.stw-ai-card::before { content:"";position:absolute;top:-40px;right:-40px;width:180px;height:180px;border-radius:50%;background:rgba(253,97,1,.15); }
.stw-ai-badge { display:inline-flex;align-items:center;gap:6px;background:rgba(255,255,255,.12);border:1px solid rgba(255,255,255,.2);border-radius:20px;padding:4px 12px;font-size:12px;font-weight:600;margin-bottom:16px; }
.stw-ai-grid { display:grid;grid-template-columns:repeat(4,1fr);gap:14px;margin-top:16px; }
.stw-ai-stat { background:rgba(255,255,255,.1);border-radius:12px;padding:14px;text-align:center;border:1px solid rgba(255,255,255,.15); }
.stw-ai-stat-lbl { font-size:10px;color:#fed7aa;text-transform:uppercase;letter-spacing:.05em; }
.stw-ai-stat-val { font-size:22px;font-weight:800;margin-top:4px; }
.stw-cbar { height:6px;background:rgba(255,255,255,.15);border-radius:3px;margin-top:10px;overflow:hidden; }
.stw-cfill { height:100%;background:#10b981;border-radius:3px;animation:fillBar 1.2s ease-out forwards; }
@keyframes fillBar { from{width:0;} }

/* REVIEW TABLE */
.stw-review-grid { display:grid;grid-template-columns:1fr 1fr;border:1px solid #e2e8f0;border-radius:14px;overflow:hidden;margin-bottom:28px; }
.stw-rc { padding:14px 18px;font-size:13px;border-bottom:1px solid #f1f5f9; }
.stw-rc:nth-child(odd)  { background:#f8fafc;color:#64748b;font-weight:600; }
.stw-rc:nth-child(even) { background:#fff;color:#0f172a;font-weight:700; }

/* KPI CARDS */
.stw-kpi-grid { display:grid;gap:14px;margin-bottom:24px; }
.stw-kg-6 { grid-template-columns:repeat(6,1fr); }
.stw-kg-7 { grid-template-columns:repeat(7,1fr); }
@media(max-width:900px){.stw-kg-6,.stw-kg-7{grid-template-columns:repeat(3,1fr);}}
.stw-kpi { background:#fff;border:1px solid #e2e8f0;border-radius:16px;padding:18px 14px;text-align:center;box-shadow:0 2px 8px rgba(0,0,0,.03);transition:all .2s; }
.stw-kpi:hover { transform:translateY(-2px);box-shadow:0 6px 20px rgba(253,97,1,.15);border-color:#FD6101; }
.stw-kpi-lbl { font-size:10px;color:#94a3b8;text-transform:uppercase;letter-spacing:.06em;font-weight:700;margin-bottom:6px; }
.stw-kpi-val { font-size:20px;font-weight:800; }
.stw-kpi-sub { font-size:10px;color:#94a3b8;margin-top:3px; }

/* PILL */
.stw-pill { display:inline-flex;align-items:center;gap:5px;padding:4px 12px;border-radius:20px;font-size:12px;font-weight:700; }
.stw-pill-g { background:#dcfce7;color:#16a34a; }
.stw-pill-r { background:#fee2e2;color:#dc2626; }
.stw-pill-p { background:#fff7ed;color:#FD6101; }

/* CHART */
.stw-chart-wrap { border:1px solid #e2e8f0;border-radius:16px;padding:20px;background:#f8fafc;margin-bottom:24px; }
.stw-chart-title { display:flex;justify-content:space-between;align-items:center;margin-bottom:14px;font-size:13px;font-weight:700;color:#475569; }
.stw-svgline { stroke-dasharray:1200;stroke-dashoffset:1200;animation:drawLine 2s ease-out forwards; }
@keyframes drawLine { to{stroke-dashoffset:0;} }

/* STAGE */
.stw-stage { display:flex;align-items:center;gap:10px;flex-wrap:wrap;background:#f1f5f9;padding:14px 18px;border-radius:12px;margin-bottom:22px;font-size:12px; }
.stw-stage-item { display:flex;align-items:center;gap:5px;font-weight:600; }

/* INSIGHTS */
.stw-insights { background:#0f172a;border-radius:14px;padding:20px;font-size:13px;line-height:2;height:160px;overflow-y:auto;margin-bottom:22px; }

/* LIMIT */
.stw-limit-card { background:#fef2f2;border:2px solid #fca5a5;border-radius:18px;padding:28px;margin-bottom:24px;position:relative;overflow:hidden; }
.stw-limit-grid { display:grid;grid-template-columns:repeat(4,1fr);gap:14px;margin-top:18px; }
.stw-limit-stat { background:#fff;border:1px solid #fecaca;border-radius:12px;padding:16px;text-align:center; }
.stw-limit-stat-lbl { font-size:10px;color:#64748b;text-transform:uppercase;letter-spacing:.05em;margin-bottom:4px; }
.stw-limit-stat-val { font-size:26px;font-weight:800; }

/* CAUSE */
.stw-cause-grid { display:grid;grid-template-columns:repeat(3,1fr);gap:16px;margin-bottom:28px; }
.stw-cause-card { border:1px solid #e2e8f0;border-radius:16px;padding:20px;background:#fff;transition:all .2s; }
.stw-cause-card:hover { box-shadow:0 6px 20px rgba(0,0,0,.06);transform:translateY(-2px); }
.stw-cause-hdr { display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:12px; }
.stw-cause-name { font-size:15px;font-weight:800;color:#0f172a; }
.stw-cause-row  { font-size:12px;color:#64748b;margin:5px 0;line-height:1.5; }
.stw-cause-row strong { color:#1e293b; }
.stw-cause-sug  { font-size:12px;color:#FD6101;font-weight:700;margin:8px 0; }
.stw-cause-imp  { font-size:12px;font-weight:800;color:#16a34a;display:flex;align-items:center;gap:5px; }

/* RECOVERY */
.stw-recovery { background:#f0fdf4;border:2px solid #86efac;border-radius:18px;padding:26px;margin-bottom:28px; }
.stw-recovery-hdr { display:flex;justify-content:space-between;align-items:center;margin-bottom:18px; }
.stw-recovery-grid { display:grid;grid-template-columns:repeat(5,1fr);gap:10px; }
.stw-recovery-check { background:#fff;border:1px solid #86efac;border-radius:12px;padding:12px 8px;text-align:center;font-size:12px;font-weight:700;color:#15803d;animation:popIn .4s ease-out backwards; }
@keyframes popIn { from{transform:scale(.8);opacity:0;} to{transform:scale(1);opacity:1;} }

/* REPORT */
.stw-report-hdr { background:#002247;border-radius:18px;padding:28px;margin-bottom:24px;color:#fff; }
.stw-grade { font-size:48px;font-weight:900;line-height:1; }

/* PERF TABLE */
.stw-perf-table { width:100%;border-collapse:collapse;font-size:13px;margin-bottom:28px; }
.stw-perf-table th { background:#f8fafc;padding:12px 16px;text-align:left;color:#475569;font-weight:700;font-size:12px;text-transform:uppercase;letter-spacing:.04em;border-bottom:2px solid #e2e8f0; }
.stw-perf-table td { padding:13px 16px;border-bottom:1px solid #f1f5f9; }
.stw-perf-table tr:hover td { background:#faf5ff; }

/* REC */
.stw-rec-grid { display:grid;grid-template-columns:repeat(3,1fr);gap:16px;margin-bottom:28px; }
.stw-rec-card { border:1px solid #e2e8f0;border-radius:16px;padding:20px;background:#fff;transition:all .2s; }
.stw-rec-card:hover { transform:translateY(-2px);box-shadow:0 8px 24px rgba(0,0,0,.07); }
.stw-rec-title { font-size:14px;font-weight:800;color:#0f172a;margin:10px 0 8px; }

/* SUMMARY */
.stw-sum-card { background:#fff7ed;border:1.5px solid #fed7aa;border-radius:18px;padding:26px;margin-bottom:28px; }
.stw-sum-row { display:flex;justify-content:space-between;align-items:center;padding:10px 0;border-bottom:1px solid rgba(253,97,1,.12);font-size:13px; }
.stw-sum-row:last-child { border-bottom:none; }

/* ADVANCED */
.stw-adv-toggle { width:100%;padding:13px 18px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:12px;font-size:13px;font-weight:700;color:#475569;cursor:pointer;display:flex;justify-content:space-between;align-items:center;transition:all .2s;text-align:left; }
.stw-adv-toggle:hover { border-color:#FD6101;color:#FD6101; }
.stw-adv-body { border:1px solid #e2e8f0;border-top:none;border-radius:0 0 12px 12px;padding:20px;background:#fff; }
.stw-adv-g3 { display:grid;grid-template-columns:repeat(3,1fr);gap:14px;margin-bottom:14px; }
.stw-adv-g2 { display:grid;grid-template-columns:1fr 1fr;gap:14px; }

/* BUTTONS */
.stw-btn-p { background:#FD6101;color:#fff;border:none;border-radius:12px;padding:13px 26px;font-size:14px;font-weight:700;cursor:pointer;transition:all .2s;box-shadow:0 4px 14px rgba(253,97,1,.35); }
.stw-btn-p:hover { background:#e05300;transform:translateY(-1px);box-shadow:0 6px 20px rgba(253,97,1,.5); }
.stw-btn-s { background:#f1f5f9;color:#475569;border:1.5px solid #e2e8f0;border-radius:12px;padding:13px 22px;font-size:14px;font-weight:600;cursor:pointer;transition:all .2s; }
.stw-btn-s:hover { border-color:#FD6101;color:#FD6101;background:#fff7ed; }
.stw-btn-row { display:flex;justify-content:space-between;align-items:center;margin-top:28px; }
.stw-btn-gap { display:flex;gap:10px;flex-wrap:wrap; }

/* MISC */
.stw-divider { height:1px;background:#f1f5f9;margin:10px 0; }
.stw-sh { font-size:15px;font-weight:800;color:#0f172a;margin:0 0 14px;display:flex;align-items:center;gap:8px; }
.stw-back-bar { display:flex;align-items:center;gap:10px;background:#f8fafc;padding:10px 16px;border-radius:12px;border:1px solid #e2e8f0;margin-bottom:22px; }
.pulse-dot { width:8px;height:8px;border-radius:50%;background:#22c55e;animation:pulse 1.5s infinite;flex-shrink:0; }
@keyframes pulse { 0%,100%{opacity:1;transform:scale(1);}50%{opacity:.5;transform:scale(1.5);} }
@keyframes cntUp { from{opacity:0;transform:translateY(6px);}to{opacity:1;transform:translateY(0);} }
.stw-av { animation:cntUp .5s ease-out; }
`;

/* ─── ANIMATED CHART ─── */
function TrafficChart({ maxUsers }) {
  const W = 600, H = 160, pad = 40;
  const pts = [[0, 0], [.05, 100], [.15, 500], [.28, 1200], [.40, 2000], [.55, 3000], [.65, 3820], [.78, 4500], [.95, maxUsers]];
  const xS = t => pad + t * (W - 2 * pad);
  const yS = u => H - pad - (u / maxUsers) * (H - 2 * pad);
  const d = "M " + pts.map(([t, u]) => `${xS(t)},${yS(u)}`).join(" L ");
  const area = d + ` L ${xS(.95)},${H - pad} L ${xS(0)},${H - pad} Z`;
  const gridYs = [0, Math.round(maxUsers * .2), Math.round(maxUsers * .4), Math.round(maxUsers * .6), Math.round(maxUsers * .8), maxUsers];
  return (
    <svg width="100%" viewBox={`0 0 ${W} ${H}`} style={{ overflow: "visible" }}>
      <defs>
        <linearGradient id="ag" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#FD6101" stopOpacity=".22" />
          <stop offset="100%" stopColor="#FD6101" stopOpacity=".02" />
        </linearGradient>
      </defs>
      {gridYs.map(u => (
        <g key={u}>
          <line x1={pad} y1={yS(u)} x2={W - pad} y2={yS(u)} stroke="#f1f5f9" strokeWidth="1" />
          <text x={pad - 6} y={yS(u) + 4} fontSize="9" fill="#94a3b8" textAnchor="end">{u >= 1000 ? `${(u / 1000).toFixed(0)}k` : u}</text>
        </g>
      ))}
      <path d={area} fill="url(#ag)" />
      <path d={d} fill="none" stroke="#FD6101" strokeWidth="3" strokeLinecap="round" className="stw-svgline" />
      <line x1={xS(.65)} y1={pad} x2={xS(.65)} y2={H - pad} stroke="#ef4444" strokeWidth="1.5" strokeDasharray="4,3" opacity=".7" />
      <text x={xS(.65) + 4} y={pad + 14} fontSize="9" fill="#ef4444" fontWeight="700">Current: 3,820</text>
      <line x1={pad} y1={H - pad} x2={W - pad} y2={H - pad} stroke="#e2e8f0" strokeWidth="1.5" />
      <text x={W / 2} y={H - 4} fontSize="9" fill="#94a3b8" textAnchor="middle">Time →</text>
    </svg>
  );
}

/* ─── LIVE INSIGHTS FEED ─── */
const ALL_INS = [
  { c: "#4ade80", i: "✓", t: "Login is responding normally." },
  { c: "#4ade80", i: "✓", t: "Dashboard is healthy." },
  { c: "#4ade80", i: "✓", t: "Students module is stable." },
  { c: "#fbbf24", i: "⚠", t: "Reports page is becoming slower." },
  { c: "#fbbf24", i: "⚠", t: "Response time increased by 18%." },
  { c: "#fbbf24", i: "⚠", t: "CPU usage is increasing rapidly." },
  { c: "#4ade80", i: "✓", t: "Database connection pool is healthy." },
  { c: "#ef4444", i: "✗", t: "Reports API latency exceeded 3s threshold." },
  { c: "#fbbf24", i: "⚠", t: "Memory usage climbing — 74% of limit." },
  { c: "#4ade80", i: "✓", t: "Login authentication still responding fast." },
  { c: "#fbbf24", i: "⚠", t: "Detected N+1 query pattern in Reports module." },
];
function InsightsFeed() {
  const [lines, setLines] = React.useState(ALL_INS.slice(0, 4));
  const [idx, setIdx] = React.useState(4);
  const ref = React.useRef(null);
  React.useEffect(() => {
    const iv = setInterval(() => {
      setLines(prev => [...prev, ALL_INS[idx % ALL_INS.length]].slice(-8));
      setIdx(i => i + 1);
    }, 2000);
    return () => clearInterval(iv);
  }, [idx]);
  React.useEffect(() => { if (ref.current) ref.current.scrollTop = ref.current.scrollHeight; }, [lines]);
  return (
    <div className="stw-insights" ref={ref}>
      {lines.map((l, i) => (
        <div key={i} style={{ display: "flex", gap: 8, color: l.c }}>
          <span>{l.i}</span><span>{l.t}</span>
        </div>
      ))}
    </div>
  );
}

/* ═══════════════════════════════════
   MAIN WIZARD
═══════════════════════════════════ */
export default function StressTestingWizard({ setWizardStep, setSelectedTestType }) {
  const [step, setStep] = React.useState(1);
  const [form, setForm] = React.useState({
    name: "Education CRM Stress Test",
    application: "Education CRM",
    environment: "QA",
    url: "https://crm.rabbitai.com",
    scope: "Complete User Journey",
    normalUsers: 100,
    testUsers: 5000,
    rampType: "Slowly",
    goal: "Find where the application starts slowing down",
  });
  const [adv, setAdv] = React.useState({
    initialUsers: 50, userIncrement: 250, rampUpInterval: "30s",
    stopConditions: "Error rate > 5%", slaThreshold: "3000ms", thinkTime: "2s",
    loadGenerators: "2 Distributed Nodes (US East)", browser: "Chrome",
    network: "WiFi", monitoring: "CPU, Memory, DB Pool", envVars: "NODE_ENV=qa",
    customPattern: "Linear Ramp", recoveryRules: "Verify 200 OK within 60s"
  });
  const [showAdv, setShowAdv] = React.useState(false);

  const STEPS = [
    { n: 1, label: "1. Create Test" }, { n: 2, label: "2. Set Goal" },
    { n: 3, label: "3. Review" }, { n: 4, label: "4. Live Test" },
    { n: 5, label: "5. Limit Found" }, { n: 6, label: "6. Recovery" },
    { n: 7, label: "7. AI Report" },
  ];

  const scopeCards = [
    { id: "Single Page", icon: "🟣", title: "Single Page", desc: "Test one target URL or landing page" },
    { id: "Complete User Journey", icon: "🟣", title: "Complete User Journey", desc: "End-to-end full user session" },
    { id: "Existing Functional Test", icon: "🟣", title: "Existing Functional Test", desc: "Reuse Playwright / Cypress scripts" },
    { id: "API Collection", icon: "🟣", title: "API Collection", desc: "Stress test REST / OpenAPI collections" },
  ];

  const rampOptions = [
    { id: "Slowly", emoji: "🟢", badge: "Recommended", color: "#16a34a", bg: "#dcfce7" },
    { id: "Moderately", emoji: "🟡", badge: "", color: "#d97706", bg: "#fef3c7" },
    { id: "Aggressively", emoji: "🔴", badge: "", color: "#dc2626", bg: "#fee2e2" },
    { id: "AI Decides", emoji: "🤖", badge: "Smart", color: "#FD6101", bg: "#ede9fe" },
  ];

  const goalOptions = [
    { id: "Find maximum users", icon: "🔍", label: "Find Maximum Users" },
    { id: "Find where the application starts slowing down", icon: "⚠️", label: "Find Slowdown Point" },
    { id: "Find breaking point", icon: "💥", label: "Find Breaking Point" },
    { id: "Verify auto-recovery", icon: "♻️", label: "Verify Auto-Recovery" },
    { id: "Let AI decide", icon: "🤖", label: "Let AI Decide" },
  ];

  const causeCards = [
    {
      name: "Reports Module", priority: "High", pColor: "#dc2626", pBg: "#fee2e2",
      problem: "Reports page became slow under heavy traffic.",
      reason: "Large unindexed database query executing on every request.",
      suggestion: "Add composite index on date + user_id and optimize SQL query.",
      improvement: "42%"
    },
    {
      name: "Dashboard", priority: "Medium", pColor: "#d97706", pBg: "#fef3c7",
      problem: "Too many parallel API requests causing thread exhaustion.",
      reason: "Unbatched endpoint calls — 12 requests per page load.",
      suggestion: "Merge into 2 aggregated API calls using batch endpoint.",
      improvement: "18%"
    },
    {
      name: "Database", priority: "High", pColor: "#dc2626", pBg: "#fee2e2",
      problem: "Database struggled to serve concurrent users.",
      reason: "Connection pool exhausted at ~4,200 concurrent sessions.",
      suggestion: "Increase pool from 10 to 50 connections + add read replica.",
      improvement: "35%"
    },
  ];

  const perfTable = [
    { screen: "Login", speed: "1.2s", status: "Excellent", ok: true },
    { screen: "Dashboard", speed: "1.8s", status: "Good", ok: true },
    { screen: "Students", speed: "2.1s", status: "Good", ok: true },
    { screen: "Reports", speed: "4.6s", status: "Needs Improvement", ok: false },
    { screen: "Logout", speed: "1.1s", status: "Excellent", ok: true },
  ];

  const recCards = [
    { priority: "High", pColor: "#dc2626", pBg: "#fee2e2", title: "Optimize Reports SQL Query", improvement: "42%", time: "6 Hours" },
    { priority: "Medium", pColor: "#d97706", pBg: "#fef3c7", title: "Reduce Dashboard API Calls", improvement: "18%", time: "4 Hours" },
    { priority: "High", pColor: "#dc2626", pBg: "#fee2e2", title: "Increase DB Connection Pool", improvement: "35%", time: "2 Hours" },
  ];

  const recoveryChecks = ["✅ Login Working", "✅ Dashboard Working", "✅ APIs Responding", "✅ Database Healthy", "✅ Application Stable"];

  return (
    <div className="stw-wrap">
      <style>{CSS}</style>

      {/* ── BACK BAR ── */}
      <div className="stw-back-bar">
        <button className="stw-btn-s" style={{ padding: "6px 14px", fontSize: "12px" }}
          onClick={() => setWizardStep(1)}>← Profile Selection</button>
        <span style={{ fontSize: "14px", fontWeight: "700", color: "#475569" }}>
          🔥 AI Stress Testing — <span style={{ color: "#FD6101" }}>{form.name}</span>
        </span>
        <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: "6px" }}>
          <div className="pulse-dot" />
          <span style={{ fontSize: "11px", color: "#64748b", fontWeight: "600" }}>AI Powered</span>
        </div>
      </div>

      {/* ── STEP NAV ── */}
      <div className="stw-nav">
        {STEPS.map(s => (
          <div key={s.n}
            className={`stw-nav-item ${step === s.n ? "active" : step > s.n ? "done" : ""}`}
            onClick={() => step > s.n && setStep(s.n)}>
            {step > s.n ? "✓ " : ""}{s.label}
          </div>
        ))}
      </div>

      {/* ═══════════ STEP 1 — CREATE STRESS TEST ═══════════ */}
      {step === 1 && (
        <div className="stw-card stw-card-sm">
          <h2 className="stw-title">📝 Create Stress Test</h2>
          <p className="stw-sub">Configure your test in under 2 minutes. RabbitAI handles everything else.</p>

          <div style={{ marginBottom: 18 }}>
            <label className="stw-label">Test Name</label>
            <input className="stw-input" value={form.name}
              onChange={e => setForm({ ...form, name: e.target.value })} />
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 18 }}>
            <div>
              <label className="stw-label">Application</label>
              <select className="stw-input stw-select" value={form.application}
                onChange={e => setForm({ ...form, application: e.target.value })}>
                <option>Education CRM</option><option>IT CRM</option>
                <option>RabbitAI Portal</option><option>Custom Application</option>
              </select>
            </div>
            <div>
              <label className="stw-label">Environment</label>
              <select className="stw-input stw-select" value={form.environment}
                onChange={e => setForm({ ...form, environment: e.target.value })}>
                <option>Development</option><option>QA</option>
                <option>UAT</option><option>Production</option>
              </select>
            </div>
          </div>

          <div style={{ marginBottom: 22 }}>
            <label className="stw-label">Application URL</label>
            <input className="stw-input" type="url" value={form.url}
              placeholder="https://crm.rabbitai.com"
              onChange={e => setForm({ ...form, url: e.target.value })} />
          </div>

          <div style={{ marginBottom: 22 }}>
            <label className="stw-label" style={{ marginBottom: 12 }}>What would you like to test?</label>
            <div className="stw-cgrid-2">
              {scopeCards.map(c => (
                <div key={c.id} className={`stw-choice ${form.scope === c.id ? "sel" : ""}`}
                  onClick={() => setForm({ ...form, scope: c.id })} style={{ textAlign: "left" }}>
                  <div className="stw-choice-icon">{c.icon}</div>
                  <div className="stw-choice-title">{c.title}</div>
                  <div className="stw-choice-desc">{c.desc}</div>
                </div>
              ))}
            </div>
          </div>

          {form.scope === "Complete User Journey" && (
            <div className="stw-journey">
              {["Login", "Dashboard", "Students", "Reports", "Logout"].map((s, i, arr) => (
                <React.Fragment key={s}>
                  <span className="stw-journey-step">{s}</span>
                  {i < arr.length - 1 && <span className="stw-journey-arrow">↓</span>}
                </React.Fragment>
              ))}
            </div>
          )}

          <div className="stw-btn-row">
            <button className="stw-btn-s" onClick={() => setWizardStep(1)}>← Back</button>
            <button className="stw-btn-p" onClick={() => setStep(2)}>Continue →</button>
          </div>
        </div>
      )}

      {/* ═══════════ STEP 2 — TELL RABBITAI YOUR GOAL ═══════════ */}
      {step === 2 && (
        <div className="stw-card stw-card-md">
          <h2 className="stw-title">🤖 Tell RabbitAI Your Goal</h2>
          <p className="stw-sub">Answer 3 simple questions. RabbitAI configures everything else automatically.</p>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 24 }}>
            <div>
              <label className="stw-label">How many users normally use your application?</label>
              <input className="stw-input" type="number" value={form.normalUsers}
                onChange={e => setForm({ ...form, normalUsers: parseInt(e.target.value) || 100 })} />
            </div>
            <div>
              <label className="stw-label">How many users would you like RabbitAI to test?</label>
              <input className="stw-input" type="number" value={form.testUsers}
                onChange={e => setForm({ ...form, testUsers: parseInt(e.target.value) || 5000 })} />
            </div>
          </div>

          <div style={{ marginBottom: 24 }}>
            <label className="stw-label" style={{ marginBottom: 12 }}>How should RabbitAI increase the traffic?</label>
            <div className="stw-cgrid-4">
              {rampOptions.map(r => (
                <div key={r.id} className={`stw-choice ${form.rampType === r.id ? "sel" : ""}`}
                  onClick={() => setForm({ ...form, rampType: r.id })}>
                  <div style={{ fontSize: 28, marginBottom: 6 }}>{r.emoji}</div>
                  <div className="stw-choice-title">{r.id}</div>
                  {r.badge && <span style={{ fontSize: 9, background: r.bg, color: r.color, padding: "2px 6px", borderRadius: 4, fontWeight: 700, marginTop: 4, display: "inline-block" }}>{r.badge}</span>}
                </div>
              ))}
            </div>
          </div>

          <div style={{ marginBottom: 24 }}>
            <label className="stw-label" style={{ marginBottom: 12 }}>What would you like RabbitAI to do?</label>
            <div className="stw-cgrid-2">
              {goalOptions.map(g => (
                <div key={g.id} className={`stw-choice ${form.goal === g.id ? "sel" : ""}`}
                  onClick={() => setForm({ ...form, goal: g.id })}
                  style={{ textAlign: "left", display: "flex", alignItems: "center", gap: 10, padding: "14px 16px" }}>
                  <span style={{ fontSize: 22 }}>{g.icon}</span>
                  <span className="stw-choice-title" style={{ fontSize: 13 }}>{g.label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* AI Recommendation Card */}
          <div className="stw-ai-card">
            <div className="stw-ai-badge">🤖 RabbitAI Recommendation</div>
            <p style={{ fontSize: 13, color: "#c4b5fd", margin: "0 0 4px 0" }}>
              Based on your application profile and {form.normalUsers} normal users, RabbitAI recommends:
            </p>
            <div className="stw-ai-grid">
              {[
                { label: "Recommended Max Users", val: "4,800", color: "#4ade80" },
                { label: "Estimated Breaking Point", val: "5,200", color: "#f87171" },
                { label: "Estimated Test Duration", val: "18 min", color: "#a5b4fc" },
                { label: "Confidence", val: "97%", color: "#fbbf24", bar: true },
              ].map(s => (
                <div key={s.label} className="stw-ai-stat">
                  <div className="stw-ai-stat-lbl">{s.label}</div>
                  <div className="stw-ai-stat-val" style={{ color: s.color }}>{s.val}</div>
                  {s.bar && <div className="stw-cbar"><div className="stw-cfill" style={{ width: "97%" }} /></div>}
                </div>
              ))}
            </div>
            <div style={{ display: "flex", gap: 10, marginTop: 18 }}>
              <button className="stw-btn-p" style={{ fontSize: 13, padding: "10px 18px" }}
                onClick={() => { setForm({ ...form, testUsers: 4800 }); setStep(3); }}>
                Use AI Recommendation ✨
              </button>
              <button style={{ background: "rgba(255,255,255,.12)", border: "1px solid rgba(255,255,255,.2)", color: "#e2e8f0", borderRadius: 10, padding: "10px 18px", fontSize: 13, cursor: "pointer", fontWeight: 600 }}
                onClick={() => setStep(3)}>
                Customize
              </button>
            </div>
          </div>

          {/* Advanced Settings */}
          <div style={{ marginBottom: 24 }}>
            <button className="stw-adv-toggle" onClick={() => setShowAdv(!showAdv)}>
              <span>⚙️ Advanced Settings <span style={{ fontSize: 11, color: "#94a3b8", fontWeight: 400 }}>(For Performance Engineers)</span></span>
              <span>{showAdv ? "▲ Hide" : "▼ Expand"}</span>
            </button>
            {showAdv && (
              <div className="stw-adv-body">
                <div className="stw-adv-g3">
                  {[["Initial Users", "initialUsers", "number"], ["User Increment", "userIncrement", "number"],
                  ["Ramp-Up Interval", "rampUpInterval", "text"], ["Stop Conditions", "stopConditions", "text"],
                  ["SLA Thresholds", "slaThreshold", "text"], ["Think Time", "thinkTime", "text"]].map(([lbl, key, typ]) => (
                    <div key={key}>
                      <label className="stw-label">{lbl}</label>
                      <input className="stw-input" type={typ} value={adv[key]}
                        onChange={e => setAdv({ ...adv, [key]: e.target.value })} />
                    </div>
                  ))}
                </div>
                <div className="stw-adv-g2">
                  {[["Load Generators", "loadGenerators"], ["Browser", "browser"], ["Network Simulation", "network"],
                  ["Monitoring Integrations", "monitoring"], ["Environment Variables", "envVars"],
                  ["Custom Load Pattern", "customPattern"], ["Recovery Validation Rules", "recoveryRules"]].map(([lbl, key]) => (
                    <div key={key}>
                      <label className="stw-label">{lbl}</label>
                      <input className="stw-input" type="text" value={adv[key]}
                        onChange={e => setAdv({ ...adv, [key]: e.target.value })} />
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="stw-btn-row">
            <button className="stw-btn-s" onClick={() => setStep(1)}>← Back</button>
            <button className="stw-btn-p" onClick={() => setStep(3)}>Continue →</button>
          </div>
        </div>
      )}

      {/* ═══════════ STEP 3 — REVIEW ═══════════ */}
      {step === 3 && (
        <div className="stw-card stw-card-sm">
          <h2 className="stw-title">🔍 Review Your Stress Test</h2>
          <p className="stw-sub">Confirm everything looks right before RabbitAI begins.</p>

          <div className="stw-review-grid">
            {[
              ["Stress Test", form.name],
              ["Application", form.application],
              ["Environment", form.environment],
              ["Application URL", form.url],
              ["Scope", form.scope],
              ["Normal Users", `${form.normalUsers} Users`],
              ["Maximum Users", `${Number(form.testUsers).toLocaleString()} Users`],
              ["Traffic Increase", form.rampType],
              ["Goal", form.goal],
              ["Estimated Duration", "18 Minutes"],
            ].map(([label, value]) => (
              <React.Fragment key={label}>
                <div className="stw-rc">{label}</div>
                <div className="stw-rc">{value}</div>
              </React.Fragment>
            ))}
          </div>

          <div style={{ background: "#fff7ed", border: "1.5px solid #fed7aa", borderRadius: 14, padding: "16px 20px", marginBottom: 24, display: "flex", alignItems: "center", gap: 12 }}>
            <span style={{ fontSize: 24 }}>🤖</span>
            <div>
              <div style={{ fontWeight: 700, fontSize: 13, color: "#FD6101" }}>RabbitAI is ready</div>
              <div style={{ fontSize: 12, color: "#64748b" }}>AI will auto-configure the ramp schedule, monitor all pages, detect bottlenecks, and generate a full report.</div>
            </div>
          </div>

          <div className="stw-btn-row">
            <button className="stw-btn-s" onClick={() => setStep(2)}>← Back</button>
            <button className="stw-btn-p" onClick={() => setStep(4)}>⚡ Run Stress Test</button>
          </div>
        </div>
      )}

      {/* ═══════════ STEP 4 — LIVE TEST ═══════════ */}
      {step === 4 && (
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 22 }}>
            <div>
              <h2 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: "#0f172a" }}>⚡ Live Stress Testing Cockpit</h2>
              <p style={{ margin: "4px 0 0", fontSize: 13, color: "#64748b" }}>
                Target: <strong>{form.url}</strong> · {form.application} · {form.environment}
              </p>
            </div>
            <span className="stw-pill stw-pill-g" style={{ fontSize: 13 }}>
              <div className="pulse-dot" /> Running Normally
            </span>
          </div>

          {/* KPI Grid */}
          <div className="stw-kpi-grid stw-kg-6">
            {[
              { label: "Application Status", val: "🟢 Running", color: "#16a34a" },
              { label: "Current Users", val: "3,820", color: "#FD6101", sub: `of ${Number(form.testUsers).toLocaleString()}` },
              { label: "Current Speed", val: "1.8 sec", color: "FD6101" },
              { label: "Requests / sec", val: "1,240", color: "#4f46e5" },
              { label: "Error Rate", val: "1.2%", color: "#dc2626" },
              { label: "Progress", val: "72%", color: "#0284c7", sub: "~5 min remaining" },
            ].map((k, i) => (
              <div key={i} className="stw-kpi">
                <div className="stw-kpi-lbl">{k.label}</div>
                <div className="stw-kpi-val stw-av" style={{ color: k.color }}>{k.val}</div>
                {k.sub && <div className="stw-kpi-sub">{k.sub}</div>}
              </div>
            ))}
          </div>

          {/* Traffic Chart */}
          <div className="stw-chart-wrap">
            <div className="stw-chart-title">
              <span>📈 Traffic Growth Curve</span>
              <span className="stw-pill stw-pill-p" style={{ fontSize: 11 }}>Target: {Number(form.testUsers).toLocaleString()} Users</span>
            </div>
            <TrafficChart maxUsers={form.testUsers} />
          </div>

          {/* Stage Tracker */}
          <div className="stw-stage">
            <strong style={{ color: "#334155", marginRight: 4 }}>Current Stage:</strong>
            <span className="stw-stage-item" style={{ color: "#16a34a" }}>✓ Normal Traffic</span>
            <span style={{ color: "#94a3b8" }}>→</span>
            <span className="stw-stage-item" style={{ color: "#16a34a" }}>✓ Increasing Users</span>
            <span style={{ color: "#94a3b8" }}>→</span>
            <span className="stw-stage-item" style={{ color: "#FD6101" }}>⏳ Finding System Limit</span>
            <span style={{ color: "#94a3b8" }}>→</span>
            <span className="stw-stage-item" style={{ color: "#94a3b8" }}>Recovery Validation</span>
          </div>

          {/* Live Insights */}
          <h3 className="stw-sh">🤖 RabbitAI Live Insights</h3>
          <InsightsFeed />

          <div className="stw-btn-row" style={{ justifyContent: "flex-end" }}>
            <button className="stw-btn-p" onClick={() => setStep(5)}>View System Limit →</button>
          </div>
        </div>
      )}

      {/* ═══════════ STEP 5 — RABBITAI FOUND THE LIMIT ═══════════ */}
      {step === 5 && (
        <div>
          <div className="stw-limit-card">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <h2 style={{ margin: 0, fontSize: 22, fontWeight: 900, color: "#dc2626" }}>🚨 RabbitAI Found Your System Limit</h2>
              <span className="stw-pill stw-pill-r">Limit Discovered</span>
            </div>
            <p style={{ fontSize: 13, color: "#64748b", margin: "8px 0 0" }}>
              RabbitAI analyzed {Number(form.testUsers).toLocaleString()} simulated users and identified these critical thresholds:
            </p>
            <div className="stw-limit-grid">
              {[
                { label: "Maximum Stable Users", val: "4,760", color: "#16a34a" },
                { label: "Started Slowing Down", val: "4,320", color: "#d97706" },
                { label: "Application Failed At", val: "4,950", color: "#dc2626" },
                { label: "Recovery Time", val: "48 sec", color: "FD6101" },
              ].map(s => (
                <div key={s.label} className="stw-limit-stat">
                  <div className="stw-limit-stat-lbl">{s.label}</div>
                  <div className="stw-limit-stat-val" style={{ color: s.color }}>{s.val}</div>
                </div>
              ))}
            </div>
          </div>

          <h3 className="stw-sh">💡 RabbitAI Root Cause Analysis</h3>
          <div className="stw-cause-grid">
            {causeCards.map(c => (
              <div className="stw-cause-card" key={c.name}>
                <div className="stw-cause-hdr">
                  <span className="stw-cause-name">{c.name}</span>
                  <span style={{ background: c.pBg, color: c.pColor, padding: "2px 10px", borderRadius: 6, fontSize: 11, fontWeight: 700 }}>{c.priority} Priority</span>
                </div>
                <div className="stw-cause-row"><strong>Problem:</strong> {c.problem}</div>
                <div className="stw-cause-row"><strong>Reason:</strong> {c.reason}</div>
                <div className="stw-cause-sug">🤖 {c.suggestion}</div>
                <div className="stw-divider" />
                <div className="stw-cause-imp">📈 Expected improvement: <span style={{ fontSize: 18 }}>{c.improvement}</span></div>
              </div>
            ))}
          </div>

          <div className="stw-btn-row">
            <button className="stw-btn-s" onClick={() => setStep(4)}>← Back to Live Test</button>
            <button className="stw-btn-p" onClick={() => setStep(6)}>View Recovery Check →</button>
          </div>
        </div>
      )}

      {/* ═══════════ STEP 6 — RECOVERY CHECK ═══════════ */}
      {step === 6 && (
        <div>
          <div className="stw-recovery">
            <div className="stw-recovery-hdr">
              <div>
                <h2 style={{ margin: 0, fontSize: 20, fontWeight: 800, color: "#15803d" }}>♻️ Automatic Recovery Validation</h2>
                <p style={{ margin: "4px 0 0", fontSize: 13, color: "#166534" }}>
                  RabbitAI verified the application returned to normal after the traffic burst.
                </p>
              </div>
              <div style={{ textAlign: "center" }}>
                <div style={{ fontSize: 32, fontWeight: 900, color: "#15803d" }}>48s</div>
                <div style={{ fontSize: 11, color: "#166534", fontWeight: 600 }}>Recovery Time</div>
              </div>
            </div>
            <div className="stw-recovery-grid">
              {recoveryChecks.map((c, i) => (
                <div key={c} className="stw-recovery-check" style={{ animationDelay: `${i * 0.12}s` }}>{c}</div>
              ))}
            </div>
            <div style={{ marginTop: 20, padding: "16px 20px", background: "#fff", borderRadius: 12, border: "1px solid #86efac", display: "flex", alignItems: "center", gap: 14 }}>
              <span style={{ fontSize: 32 }}>🏁</span>
              <div>
                <div style={{ fontWeight: 800, fontSize: 15, color: "#15803d" }}>Recovery Completed Successfully</div>
                <div style={{ fontSize: 13, color: "#166534", marginTop: 2 }}>Application returned to normal baseline in 48 seconds. All services stable.</div>
              </div>
            </div>
          </div>
          <div className="stw-btn-row">
            <button className="stw-btn-s" onClick={() => setStep(5)}>← Back</button>
            <button className="stw-btn-p" onClick={() => setStep(7)}>View AI Report →</button>
          </div>
        </div>
      )}

      {/* ═══════════ STEP 7 — AI REPORT ═══════════ */}
      {step === 7 && (
        <div>
          {/* Report Header */}
          <div className="stw-report-hdr">
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
              <div>
                <span style={{ background: "#22c55e", color: "#fff", padding: "4px 12px", borderRadius: 20, fontSize: 11, fontWeight: 700 }}>✅ PRODUCTION READY</span>
                <h2 style={{ margin: "12px 0 4px", fontSize: 24, fontWeight: 900 }}>📋 AI Stress Test Report</h2>
                <p style={{ margin: 0, fontSize: 13, color: "#a5b4fc" }}>
                  {form.application} · {form.environment} · Run ID: <strong>PERF-STRESS-2026</strong>
                </p>
              </div>
              <div style={{ textAlign: "center" }}>
                <div className="stw-grade">A-</div>
                <div style={{ fontSize: 13, color: "#a5b4fc" }}>Health: 91/100</div>
              </div>
            </div>
          </div>

          {/* KPI Grid */}
          <div className="stw-kpi-grid stw-kg-7">
            {[
              { label: "Overall Health", val: "91/100", color: "#22c55e" },
              { label: "Performance Grade", val: "A-", color: "#FD6101" },
              { label: "Max Users Handled", val: "4,760", color: "#16a34a" },
              { label: "Slowed Down At", val: "4,320", color: "#d97706" },
              { label: "Failed At", val: "4,950", color: "#dc2626" },
              { label: "Recovery", val: "Successful", color: "#16a34a" },
              { label: "Production Ready", val: "✅ YES", color: "#16a34a" },
            ].map((k, i) => (
              <div key={i} className="stw-kpi">
                <div className="stw-kpi-lbl">{k.label}</div>
                <div className="stw-kpi-val" style={{ color: k.color, fontSize: k.val.length > 6 ? 14 : 20 }}>{k.val}</div>
              </div>
            ))}
          </div>

          {/* Screen Performance Table */}
          <h3 className="stw-sh">📱 Screen Performance Summary</h3>
          <table className="stw-perf-table">
            <thead>
              <tr><th>Screen</th><th>Response Speed</th><th>Status</th></tr>
            </thead>
            <tbody>
              {perfTable.map(row => (
                <tr key={row.screen}>
                  <td style={{ fontWeight: 700, color: "#0f172a" }}>{row.screen}</td>
                  <td style={{ color: "#475569" }}>{row.speed}</td>
                  <td style={{ color: row.ok ? "#16a34a" : "#d97706", fontWeight: 700 }}>
                    {row.ok ? "🟢" : "🟠"} {row.status}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* RabbitAI Recommendations */}
          <h3 className="stw-sh">💡 RabbitAI Optimization Recommendations</h3>
          <div className="stw-rec-grid">
            {recCards.map(r => (
              <div key={r.title} className="stw-rec-card">
                <span style={{ background: r.pBg, color: r.pColor, padding: "3px 10px", borderRadius: 6, fontSize: 11, fontWeight: 700 }}>{r.priority} Priority</span>
                <div className="stw-rec-title">{r.title}</div>
                <div style={{ fontSize: 12, color: "#64748b" }}>
                  <div>Estimated Improvement: <strong style={{ color: "#16a34a", fontSize: 15 }}>{r.improvement}</strong></div>
                  <div style={{ marginTop: 4 }}>Estimated Time: <strong>{r.time}</strong></div>
                </div>
                <div style={{ marginTop: 12, height: 4, background: "#f1f5f9", borderRadius: 2, overflow: "hidden" }}>
                  <div style={{ height: "100%", width: r.improvement, background: r.pColor, borderRadius: 2 }} />
                </div>
              </div>
            ))}
          </div>

          {/* Final Summary */}
          <div className="stw-sum-card">
            <h3 style={{ margin: 0, fontSize: 16, fontWeight: 800, color: "#FD6101" }}>🏁 Final Executive Summary</h3>
            <div style={{ marginTop: 14 }}>
              {[
                ["Application Health", "Excellent", "#16a34a"],
                ["Max Users Successfully Handled", "4,760 Users", "#0f172a"],
                ["Application Started Slowing", "4,320 Users", "#d97706"],
                ["Application Failed", "4,950 Users", "#dc2626"],
                ["Recovery", "Recovered in 48s", "#16a34a"],
                ["Ready for Production", "✅ Yes", "#16a34a"],
              ].map(([label, val, color]) => (
                <div key={label} className="stw-sum-row">
                  <span style={{ color: "#64748b", fontWeight: 600 }}>{label}</span>
                  <span style={{ fontWeight: 800, color }}>{val}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Action Buttons */}
          <div className="stw-btn-row">
            <div className="stw-btn-gap">
              <button className="stw-btn-s" onClick={() => alert("PDF report generated!")}>📄 PDF</button>
              <button className="stw-btn-s" onClick={() => alert("Excel sheet ready!")}>📊 Excel</button>
              <button className="stw-btn-s" onClick={() => alert("Shareable link copied!")}>🔗 Share Report</button>
              <button className="stw-btn-s" onClick={() => alert("Opening comparison...")}>📂 Compare Previous</button>
            </div>
            <button className="stw-btn-p" onClick={() => setStep(1)}>🔄 New Stress Test</button>
          </div>
        </div>
      )}
    </div>
  );
}











